import { createFileRoute } from '@tanstack/react-router'
import { MailCheck } from 'lucide-react'
import { Button } from '@platform/ui'
import { BrandLogo } from '@/modules/shared/BrandLogo'
import { platform } from '@/lib/platform'

/**
 * La raíz de esta instancia no es una portada: es una puerta cerrada.
 *
 * POR QUÉ NO HAY INICIO DE SESIÓN AQUÍ
 *
 * Esta rama alimenta una instancia compartida a la que solo se entra con un
 * enlace personal. Ese enlace es lo que crea la correlación con el prospecto:
 * sin él no hay a quién atribuir nada de lo que pase dentro, y la telemetría
 * —que es el producto de esta instancia— se pierde entera.
 *
 * Antes aquí vivía el inicio de sesión por código al correo. Dejarlo habría
 * abierto una segunda puerta sin atribución: alguien entraría, recorrería todo,
 * y en la bandeja comercial no aparecería nadie. Peor que no medirlo es medirlo
 * a medias y creer que el número significa algo.
 *
 * La dirección de solicitud vive en la web oficial, no aquí. Esta instancia no
 * capta: atiende a quien ya fue invitado.
 */
/**
 * Dónde se piden accesos nuevos. Es la página del mini-producto en la web
 * oficial. Se configura por entorno porque cambia entre desarrollo y despliegue,
 * y si falta simplemente no se ofrece el botón: mejor no tenerlo que tenerlo
 * roto.
 */
const URL_SOLICITUD = (import.meta.env.VITE_REQUEST_ACCESS_URL as string | undefined) ?? ''

function PuertaCerrada() {
  const marca = platform.brand?.productName ?? 'la plataforma'
  const solicitud = URL_SOLICITUD.trim() || null

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="w-full max-w-md space-y-6 text-center">
        <BrandLogo className="mx-auto h-10" />

        <div className="flex justify-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10">
            <MailCheck className="h-7 w-7 text-primary" />
          </div>
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-semibold">Se entra por invitación</h1>
          <p className="text-muted-foreground">
            {marca} se abre desde el enlace personal que te llega por correo. Buscá el último que
            te enviamos y entrá desde ahí.
          </p>
        </div>

        <p className="text-sm text-muted-foreground">
          ¿No lo encontrás o ya venció? Pedí uno nuevo y te llega al instante.
        </p>

        {solicitud ? (
          <Button asChild className="w-full">
            <a href={solicitud}>Pedir un acceso</a>
          </Button>
        ) : null}
      </div>
    </div>
  )
}

export const Route = createFileRoute('/')({
  component: PuertaCerrada,
})
